module.exports = __webpack_public_path__ + "static/img/30012 (3).4b42c1f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (3).webp
// module id = tv/K
// module chunks = 14